import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const mfaSetupDetails = createAsyncThunk('mfa_setup/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `premise_authentication/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addMfaSetup = createAsyncThunk('mfa_setup/add', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'premise_authentication',
            data: {
                premise_id: data?.values?.premise,
                mfa_allowed: data?.values?.twoWayAuth,
                defaulters_allowed: data?.values?.defaultersList,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const mfaSetup = createSlice({
    name: 'mfa_setup',
    initialState: {
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(mfaSetupDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default mfaSetup.reducer;